import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { HttpParams } from  "@angular/common/http";
import { Observable } from 'rxjs/Observable';
import { CookieService } from 'ngx-cookie';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
declare var DDP_ENV: any;

@Injectable()
export class UserPreferenceService {

	base_url: string = DDP_ENV.userServiceUrl;
	constructor(private _router: Router, private _http: Http, private cookieService: CookieService){}
	
	/* Update UI preference */
  update(preferences, user) : Observable<any>{
	return this._http.put(this.base_url + '/user/' + user.id + '/ui-preferences', preferences, this.buildHeaders())
    	.map((res: Response) => {
		      return res;
		  });
  }

  /* get  UI preference */
  get(configPath, user) : Observable<any>{
	return this._http.get(this.base_url + '/user/' + user.id + '/ui-preferences?path=' + configPath, this.buildHeadersForGet(configPath))
		              .map((res:Response) => res.json());
  }

	/* Get preferences */
	getForLoggedUser(path: string, userId: string) : Observable<any>{
		return this._http.get(this.base_url + "/user/" + userId + '/ui-preferences?path=' + path, this.buildHeadersForGet(path))
		               .map((res:Response) => res.json());
	}


	private buildHeaders(): any {
    	var headers = new Headers({'Authorization': 'Bearer '+ this.cookieService.get('ecare_access_token')
        , "client-id": localStorage.getItem('clientId')});
    	return new RequestOptions({ headers: headers });
  }

  private buildHeadersForGet(path): any {
    var headers = new Headers({'Authorization': 'Bearer '+ this.cookieService.get('ecare_access_token')
        , "client-id": localStorage.getItem('clientId')});
    return new RequestOptions({ headers: headers});
  }

}
